<template lang="pug">
  vm-row(vm-w="12" vm-type="flex" vm-justify="space-between" class="information__wrapper")
    vm-col(vm-sm=12)
      vm-row(vm-align="left" vm-type="flex" vm-justify="left" vm-w="12")
        vm-col(vm-sm=12 vm-md=6 vm-lg=3 class="gutters")
          .card.card-primary
            .card-body
              h4 ORDEN DE COMRPRA (OC)
              h3  {{ order_customer  }}
        vm-col(vm-sm=12 vm-md=6 vm-lg=3 class="gutters")
          .card
            .card-body
              h4 IMPORTE DE VENTA
              h3  {{ sale_amount | currency }}
        vm-col(vm-sm=12 vm-md=6 vm-lg=3 class="gutters")
          .card
            .card-body
              vm-row(vm-w="12" vm-type="flex" vm-justify="space-between")
                vm-col(vm-sm=12 vm-md=5 vm-lg=4)
                  vm-row(vm-w="12" vm-type="flex" vm-justify="center" vm-align="center" class="h-100 p-0")
                    .icon__wrapper
                      vm-icon(icon="person-outline" size="1.5rem" color="#036683")
                vm-col(vm-sm=12 vm-md=7 vm-lg=8)
                  h4 CLIENTE
                  h3 {{ customer }}
        vm-col(vm-sm=12 vm-md=6 vm-lg=3 class="gutters")
          .card
            .card-body
              vm-row(vm-w="12" vm-type="flex" vm-justify="space-between")
                vm-col(vm-sm=12 vm-md=5 vm-lg=4)
                  vm-row(vm-w="12" vm-type="flex" vm-justify="center" vm-align="center" class="h-100 p-0")
                    .icon__wrapper
                      vm-icon(icon="calendar-outline" size="1.5rem" color="#036683")
                vm-col(vm-sm=12 vm-md=7 vm-lg=8)
                  h4 FECHA DE VENTA
                  h3 {{ sale_date | moment('DD-MMMM-YYYY') }}
      vm-row(vm-align="left" vm-type="flex" vm-justify="left" vm-w="12")
        vm-col(vm-sm=12 vm-md=6 vm-lg=4 class="gutters")
          .card
            .card-body
              h4 IMPORTACIONES
              h3  {{ sale.imports_amount | currency  }}
        vm-col(vm-sm=12 vm-md=6 vm-lg=4 class="gutters")
          .card
            .card-body
              h4 OTROS GASTOS
              h3  {{ sale.other_expenses_amount | currency }}
        vm-col(vm-sm=12 vm-md=6 vm-lg=4 class="gutters")
          .card
            .card-body
              h4 FLETES
              h3 {{ sale.flete_display | currency }}
    .floating_sale_amount
      span Importe Venta
      span {{ sale_amount | currency }}
    .floating_sub_unit_cost
      span Subtotal Costo Unitario
      span {{ sub_unit_cost | currency }}
</template>

<script>

export default {
  name: 'GeneralSaleInformation',
  props: {
    sale: {
      type: Object,
      default: () => {}
    }
  },
  computed: {
    order_customer () {
      if (this.sale.quotation) {
        return this.sale.quotation.order_customer !== null ? `#${this.sale.quotation.order_customer}` : '#####'
      } else {
        return this.$t('sale.error')
      }
    },
    sale_amount () {
      return this.sale.total
    },
    customer () {
      if (this.sale.customer) {
        return this.sale.customer.tradename
      } else {
        return this.$t('sale.error')
      }
    },
    sale_date () {
      return this.sale.created_at
    },
    sub_unit_cost () {
      let t = this
      if (this.sale.quotation) {
        let sub = 0
        this.sale.quotation.details.map((detail, index) => {
          (parseFloat(detail.unit_price_raw) === 0.00) && (detail.unit_price_raw = detail.unit_price)
          if (detail.edit !== undefined && (parseInt(detail.product.currency_id) !== parseInt(t.sale.currency_id))) {
            (parseInt(detail.product.currency_id) === 1 ? detail.unit_price = parseFloat(parseFloat(detail.unit_price_raw) * parseFloat(t.sale.exchange_rate)).toFixed(5) : detail.unit_price = parseFloat(parseFloat(detail.unit_price_raw) / t.sale.exchange_rate).toFixed(5))
          } else if (parseInt(detail.product.currency_id) !== parseInt(t.sale.currency_id)) {
            (parseInt(detail.product.currency_id) === 1 ? detail.unit_price = parseFloat(parseFloat(detail.unit_price_raw) * parseFloat(t.sale.exchange_rate)).toFixed(5) : detail.unit_price = parseFloat(parseFloat(detail.unit_price_raw) / t.sale.exchange_rate).toFixed(5))
          } else {
            detail.unit_price = parseFloat(detail.unit_price_raw)
          }

          sub += detail.unit_price * detail.quantity
        })

        return sub
      }
    }
  }
}
</script>

<style lang="scss">
.information__wrapper {
  margin-top: 25px;
  .card {
    display: flex;
    align-items: center;
    justify-content: center;
    padding: 10px !important;
    height: 100% !important;
    border-radius: 20px !important;
    .card-body {
      padding: 10px !important;
      width: 100%;
      display: flex;
      flex-direction: column;
      align-items: center;
      justify-content: center;
      .icon__wrapper {
        padding: 10px !important;
        border-radius: 0.5em;
        background-color: #dfdfdf;
      }
    }
  }
}

.card-primary {
  background: linear-gradient(to right, rgba(3,102,131,1) 0% ,rgba(3,102,131,0.75) 100%) !important;
  color: #ffffff !important;
}

.floating_sale_amount {
  display: none;
}

@media screen and (min-width: 992px) {
.floating_sale_amount,
.floating_sub_unit_cost {
    display: flex;
    justify-content: space-between;
    position: fixed;
    bottom: 20px;
    left: 80px;
    background-color: #0082aa;
    padding: 10px;
    z-index: 20000;
    border-radius: 0.5em;
    span {
      color: #fff;
      padding: 10px;
      &:last-child {
        font-weight: bold;
      }
    }
  }
}
.floating_sub_unit_cost {
  bottom: 20px;
  left: calc(50% - 160.5px);
}
/* Globales */
h4 {
  text-align: center;
  margin-bottom: 1rem;
  font-weight: 200;
  font-size: 1.1rem;
}
h3 {
  text-align: center;
  font-weight: bold;
  font-size: 1.3rem;
}

/* Helpers */
.gutters {
  padding: 20px;
}
.h-100 {
  height: 100%;
}

.p-0 {
  padding: 0 !important;
}
</style>
